import { Config } from '../../types/config/config';

export const isEMEA = (config: Config) => config.siteId === 'cbre-im';